<template>
	<div class="">
		<div class="px-3">
			<div class="flex w-full justify-center">
				<div class="w-full max-w-8xl">
					<div class="flex w-full my-auto pb-2">
						<div class="flex w-full text-start text-ihh-midnight-gray text-xl lg:text-2xl font-semibold tracking-wide whitespace-nowrap m-auto">Image Gallery</div>
						<ImageScroller class="m-auto hidden sm:flex lg:hidden" />
					</div>

					<div class="flex w-full justify-start md:justify-center">
						<div class="grid grid-cols-2 xs:grid-cols-3 lg:grid-cols-4 gap-x-3 w-full min-w-fit md:min-w-0">
							<div
								v-for="(feature, a) in featured"
								:key="a"
								:class="{ block: a < 2, 'hidden xs:block': a >= 2 && a < 3, 'hidden lg:block': a >= 3 && a < 4, hidden: a >= 4 }"
							>
								<div
									class="relative group flex w-full justify-center bg-ihh-light-lavendar rounded-xl h-full min-h-52 md:min-h-77 max-h-77 items-center p-4 sm:p-8 md:p-10 overflow-hidden shadow"
								>
									<img class="w-full object-center object-cover" :src="feature.image" alt="featured images" />
									<div
										class="absolute inset-0 flex items-end justify-center opacity-0 bg-ihh-white/40 transition transform duration-300 ease-in-out group-hover:opacity-100"
									></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ImageScroller from './image-scroller.vue'
export default {
	components: { ImageScroller },
	data() {
		return {
			featured: [
				{
					image: '/images/Mini-LIner-0129.jpg',
					title: 'The Original Silverette - Silver Nursing Cups',
					buttonText: 'Add to Bag',
					price: '$59.99',
				},
				{
					image: '/images/liner-2-0129.jpg',
					title: 'Passages Birth Pool',
					buttonText: 'Add to Bag',
					price: '$99.00',
				},
				{
					image: '/images/MINI-1-0129.jpg',
					title: 'Rael Organic Cotton Disposable Period Underwear',
					buttonText: 'Choose Options',
					price: '$13.99',
				},
				{
					image: '/images/tub-3-0129.jpg',
					title: 'DD-901 Tabletop Fetal Doppler by Newman Medical',
					buttonText: 'Choose Options',
					price: '$799.00',
				},
			],
		}
	},
}
</script>
